import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './wizard_staff.png'

export const wizard_staff: ItemUI<Weapon> = {
    image,
    label: 'Wizard staff',
    value: 125,
    item: {
        key: 'wizard_staff',
        type: 'weapon',
        rarity: ItemRarity.Epic,
        stats: {
            intelligence: 100
        },
        two_handed: false,
        category: 'staff',
        damageType: DamageType.Melee,
        range: AttackRange.Melee,
        energy: 2,
        damage: 6
    }
}
